import { create } from "zustand";
import { PatientSessions } from "../api/types";

type SessionType = PatientSessions['sessions'][0];

interface ActiveSessionState {
  isOpen: boolean;
  selectedSession: SessionType | null;
  open: (session?: SessionType) => void;
  close: () => void;
  toggle: () => void;
  setSelectedSession: (session: SessionType | null) => void;
}

export const useActiveSessionStore = create<ActiveSessionState>((set) => ({
  isOpen: false,
  selectedSession: null,
  open: (session) => set({ isOpen: true, selectedSession: session || null }),
  close: () => set({ isOpen: false, selectedSession: null }),
  toggle: () => set((state) => ({ isOpen: !state.isOpen })),
  setSelectedSession: (session) => set({ selectedSession: session }),
}));
